export default __webpack_public_path__ + "static/media/1.e5336ade.png";